import "./DashboardTabTable.css";

import { ReactNode } from "react";

import { FullRightArrowDark } from "../../../../../assets";
import {
  Button,
  Column,
  CursorDataGrid,
  DataGridColumnDefinition,
  DataGridCursorDataLoadEventHandler,
  Row,
} from "../../../../../widget";

interface DashboardTabTableProps {
  title: string;
  columns: DataGridColumnDefinition[];
  isLoading: boolean;
  noDataMessage: string;
  onChange: DataGridCursorDataLoadEventHandler;
  onViewMore: () => void;
  // Extra controls rendered to the left of "View more" (e.g. the activities sub-tab toggle).
  actions?: ReactNode;
  gridKey?: string;
}

export const DashboardTabTable = ({
  title,
  columns,
  isLoading,
  noDataMessage,
  onChange,
  onViewMore,
  actions,
  gridKey,
}: DashboardTabTableProps): JSX.Element => {
  // Deliberately a fragment, not a wrapping div — the heading and the actions need to lay out
  // as flex items of the grid's own filter row so the "Show filters" toggle sits between them.
  const header = (
    <>
      <h2>{title}</h2>
      <div className="DashboardTabTableActions">
        {actions}
        <Button
          text="View more"
          onClick={onViewMore}
          variant="secondary"
          icon={<FullRightArrowDark />}
          minWidth={false}
          hasNoPadding
        />
      </div>
    </>
  );

  return (
    <div className="DashboardTabTable DataGridFiltersEnd">
      <Row>
        <Column span={12}>
          <CursorDataGrid
            key={gridKey}
            columns={columns}
            clientSide={false}
            pageable={false}
            filterable
            onChange={onChange}
            data={[]}
            dataIsLoading={isLoading}
            noDataMessage={noDataMessage}
            header={header}
          />
        </Column>
      </Row>
    </div>
  );
};
